export const footerCopyright = {
    en: "Inc. All Rights Reserved.",
    he: "כל הזכויות שמורות",
    ar: "جميع الحقوق محفوظة"
}